import { all, AllEffect } from "redux-saga/effects";

import { AppSaga } from "./App";
import { AutomaticRefresh } from "./AutomaticRefresh";
import { BackendSaga } from "./Backend";
import { CloneSaga } from "./Clone";
import { DeleteSaga } from "./Delete";
import { ExportSaga } from "./Export";
import { FilterSaga } from "./Filter";
import { RelevanceSaga } from "./Relevance";
import { SortSaga } from "./Sort";
import { StagingSaga } from "./Staging";
import { StorageSaga } from "./Projects";
import { UsernamesSaga } from "./Usernames";
import { VersionsSaga } from "./Versions";

export function* RootSaga(): Generator<AllEffect<unknown>, void, unknown> {
  yield all([
    AppSaga(),
    AutomaticRefresh(),
    BackendSaga(),
    CloneSaga(),
    DeleteSaga(),
    ExportSaga(),
    FilterSaga(),
    RelevanceSaga(),
    SortSaga(),
    StagingSaga(),
    StorageSaga(),
    UsernamesSaga(),
    VersionsSaga()
  ]);
}
